'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Action type
 */

var EFFECT_STORAGE = 'EFFECT_STORAGE';

var STORAGE_TYPE = {
  local: 'LOCAL',
  session: 'SESSION'
};

/**
 * redux-storage
 */

function createStorage() {
  return function (dispatch) {
    return function (next) {
      return function (action) {
        return action.type === EFFECT_STORAGE ? execute(action.payload) : next(action);
      };
    };
  };

  function execute(_ref) {
    var type = _ref.type;
    var storageType = _ref.storageType;
    var key = _ref.key;
    var value = _ref.value;
    var n = _ref.n;

    var store = storageType === STORAGE_TYPE.local ? window.localStorage : window.sessionStorage;
    switch (type) {
      case 'key':
        return Promise.resolve(store.key(n));
      case 'getItem':
        return Promise.resolve(store.getItem(key)).then(function (v) {
          return parseValue(v);
        });
      case 'setItem':
        return Promise.resolve(store.setItem(key, JSON.stringify(value)));
      case 'removeItem':
        return Promise.resolve(store.removeItem(key, value));
      case 'clear':
        return Promise.resolve(store.clear());
      case 'length':
        return Promise.resolve(store.length);
      default:
        throw new Error('redux-storage unknown storage action type');
    }
  }
}

function parseValue(value) {
  try {
    return JSON.parse(value);
  } catch (err) {
    return value;
  }

  return value; // just for consistency
}

/**
 * Action creator
 */

function createAction(payload) {
  return {
    type: EFFECT_STORAGE,
    payload: payload
  };
}

function key(n) {
  var storageType = arguments.length <= 1 || arguments[1] === undefined ? STORAGE_TYPE.local : arguments[1];

  return createAction({ type: 'key', storageType: storageType, n: n });
}

function getItem(key) {
  var storageType = arguments.length <= 1 || arguments[1] === undefined ? STORAGE_TYPE.local : arguments[1];

  return createAction({ type: 'getItem', storageType: storageType, key: key });
}

function setItem(key, value) {
  var storageType = arguments.length <= 2 || arguments[2] === undefined ? STORAGE_TYPE.local : arguments[2];

  return createAction({ type: 'setItem', storageType: storageType, key: key, value: value });
}

function removeItem(key) {
  var storageType = arguments.length <= 1 || arguments[1] === undefined ? STORAGE_TYPE.local : arguments[1];

  return createAction({ type: 'removeItem', storageType: storageType, key: key });
}

function clear() {
  var storageType = arguments.length <= 0 || arguments[0] === undefined ? STORAGE_TYPE.local : arguments[0];

  return createAction({ type: 'clear', storageType: storageType });
}

function getLength() {
  var storageType = arguments.length <= 0 || arguments[0] === undefined ? STORAGE_TYPE.local : arguments[0];

  return createAction({ type: 'length', storageType: storageType });
}

/**
 * Exports
 */

exports.default = createStorage;
exports.key = key;
exports.getItem = getItem;
exports.setItem = setItem;
exports.removeItem = removeItem;
exports.clear = clear;
exports.getLength = getLength;
exports.STORAGE_TYPE = STORAGE_TYPE;